import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { createApi } from '@reduxjs/toolkit/query/react';
import { useInjectReducer } from 'utils/redux-injectors';
import { MediaState } from './types';
import { baseQuery, endpoints } from 'utils/api/endpoints';

export const initialState: MediaState = {
  uploadedFile: null,
};

const slice = createSlice({
  name: 'media',
  initialState,
  reducers: {
    setUploadedFile(state, action: PayloadAction<any>) {
      console.log(action.payload);
      state.uploadedFile = action.payload;
    },
  },
});

export const api = createApi({
  reducerPath: 'mediaApi',
  baseQuery,
  endpoints: builder => ({
    uploadMedia: builder.mutation<any, FormData>({
      query: body => ({
        ...endpoints.uploadMedia,
        body,
      }),
    }),
    getMedia: builder.query<any, any>({
      query: ({ page, folder, search } = {}) => {
        const params = new URLSearchParams();
        if (page) params.append('page', page);
        if (folder) params.append('folder', folder);
        if (search) params.append('search', search);

        return {
          url: `${endpoints.MEDIA}?${params.toString()}`,
          method: 'GET',
        };
      },
    }),
  }),
});

export const { actions: MediaAction } = slice;

export const useMediaSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectReducer({ key: api.reducerPath, reducer: api.reducer });
  return {
    useUploadMediaMutation: api.useUploadMediaMutation,
    useGetMediaQuery: api.useLazyGetMediaQuery,
    actions: MediaAction,
  };
};
